<template>
  <div class="my-projects-container">
    <div class="title-container" v-if="collabrators != ''">
      <div class="title"><span class="title-inner" @click="collab=false" :class="collab && 'in-active'">Uploads</span><span class="title-inner" @click="collab=true" :class="!collab && 'in-active'">Collaborations</span></div>
      <a href="https://community.avishkaar.cc/projects/upload" class="orange-button" v-if="!all_projects && accessProfile">Upload Project</a>
      <a href="https://community.avishkaar.cc/projects/upload" class="utility" v-if="count >= 1 && accessProfile">
        <img class="space" src="https://images.avishkaar.cc/misc/profile/utility/upload-icon.png" alt="Upload" />
        <div class="span">Upload New Project</div>
      </a>
      <a href="https://community.avishkaar.cc/projects/upload" class="mobile-utility">
        <img class="space" src="https://images.avishkaar.cc/misc/profile/utility/upload-icon.png" alt="Upload" />
        <div class="span">Upload</div>
      </a>
    </div>
    <div class="title-container" v-else-if="accessProfile">
      <div class="title">
        Project Uploads
        <span class="space" v-if="count >= 1 && all_projects">(</span>
        <span v-if="count >= 1 && all_projects">{{ count }}</span>
        <span class="space" v-if="count >= 1 && all_projects">)</span>
      </div>
      <a href="https://community.avishkaar.cc/projects/upload" class="orange-button" v-if="!all_projects && accessProfile">Upload Project</a>
      <a href="https://community.avishkaar.cc/projects/upload" class="utility" v-if="count >= 1 && accessProfile">
        <img class="space" src="https://images.avishkaar.cc/misc/profile/utility/upload-icon.png" alt="Upload" />
        <div class="span">Upload New Project</div>
      </a>
      <a href="https://community.avishkaar.cc/projects/upload" class="mobile-utility">
        <img class="space" src="https://images.avishkaar.cc/misc/profile/utility/upload-icon.png" alt="Upload" />
        <div class="span">Upload</div>
      </a>
    </div>
    <div class="title-container" v-if="!accessProfile && count >= 1 && all_projects">
      <div class="title">
        Project Uploads
        <span class="space" v-if="count >= 1 && all_projects">(</span>
        <span v-if="count >= 1 && all_projects">{{ count }}</span>
        <span class="space" v-if="count >= 1 && all_projects">)</span>
      </div>
    </div>
    <div class="no-project-no-kits" v-if="courseData == '' && !all_projects && accessProfile && !collab">
      <div class="sub-title">Even the revolutionaries need skills and tools to innovate</div>
      <div class="content">Take this 2-minutes quiz to find out the perfect kit or course for you</div>
      <button class="orange-button" @click="openModal">Take Quiz</button>
      <div class="or">OR</div>
      <div class="content"><a href="https://shop.avishkaar.cc/courses/innovators-launchpad-course"><span class="highlight">Register</span></a>
        For Innovator's Launchpad Course
        For Free Using Code 'ILC-LETS-AVISHKAAR' To Make Your Very First
        Project.
      </div>
    </div>
    <div class="no-project-but-kits" v-else-if="!all_projects && courseData.length >= 1 && accessProfile && !collab">
      <div class="sub-title">Why are you waiting to innovate with your awesome kits?</div>
      <div class="content">Start with one of the free courses, compatible with your kits and make
        your very first project today!</div>
      <div class="course-card-container">
        <div class="course-card" :key="index" v-for="(item,index) in courseData" >
          <img :src="item.course_image" class="course-thumbnail" alt="Thumbnail" />
          <div class="sub-title">{{item.course_name}}</div>
          <div class="content">Learn to create</div>
          <button class="orange-button"><a class="link-class" :href="get_web_path + '/course/' + item.course_code">Start Learning</a></button>
        </div>
      </div>
    </div>
    <div class="projects-added" v-else-if="collabrators != '' && collab">
      <a v-for="content in collabrators" :key="content.project_id" :href="'https://community.avishkaar.cc/project/' + content.project_uri" class="link-class project-card">
        <div class="project-thumbnail" :style="'background-image: url(' + (content.project_thumbnail ? (content.project_thumbnail.includes('https') ? content.project_thumbnail : 'https://avishkaar-users.s3.amazonaws.com/' + content.project_thumbnail) : 'https://images.avishkaar.cc/projects-default-thumbnail.webp') + ');'" >
          <div class="thumbnail-overlay">
            <div class="project-date">{{ content.creation_date | formatDate }}</div>
            <div class="button-container"><button class="orange-button">View Project</button></div>
          </div>
        </div>
        <div class="project-title">
          <div class="sub-title">{{ content.project_title }}</div>
          <div class="project-views">
            <img src="https://images.avishkaar.cc/misc/profile/utility/eye-icon.png" alt="Views" />
            <span class="views-total">{{ content.views }}</span>
          </div>
        </div>
        <div class="content scrollbar">{{ content.description }}</div>
      </a>
    </div>
    <div class="projects-added" v-else-if="count >= 1 && all_projects && !collab">
      <a v-for="content in all_projects" :key="content.project_id" :href="'https://community.avishkaar.cc/project/' + content.project_uri" class="link-class project-card">
        <div class="project-thumbnail" :style="'background-image: url(' + (content.project_thumbnail ? (content.project_thumbnail.includes('https') ? content.project_thumbnail : 'https://avishkaar-users.s3.amazonaws.com/' + content.project_thumbnail) : 'https://images.avishkaar.cc/projects-default-thumbnail.webp') + ');'" >
          <div class="thumbnail-overlay">
            <div class="project-date">{{ content.creation_date | formatDate }}</div>
            <div class="button-container"><button class="orange-button">View Project</button></div>
          </div>
        </div>
        <div class="project-title">
          <div class="sub-title">{{ content.project_title }}</div>
          <div class="project-views">
            <img src="https://images.avishkaar.cc/misc/profile/utility/eye-icon.png" alt="Views" />
            <span class="views-total">{{ content.views }}</span>
          </div>
        </div>
        <div class="content scrollbar">{{ content.description }}</div>
      </a>
    </div>
    <div class="no-projects-no-access" v-else-if="!accessProfile && !all_projects && !collab">
      <img src="https://images.avishkaar.cc/misc/profile/images/no-uploads-image.png" class="no-projects-no-access-img" alt="Still Tinkering" />
      <img src="https://images.avishkaar.cc/misc/profile/images/no-uploads-image-mobile.png" class="no-projects-no-access-img-mobile" alt="Still Tinkering" />
      <div class="title">{{this.$route.params.userName}} is still tinkering to upload their project</div>
      <div class="content">Come back in a while to check out their creative innovation !</div>
    </div>
    <div class="loading" v-else>
      <img src="https://images.avishkaar.cc/misc/projects/loading-icon.svg" />
      <div class="sub-title">Loading...</div>
    </div>
    <Modal v-show="uploadModal" @close="closeModal"></Modal>
     <productFinder />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Modal from "@/components/projects/Dialog.vue";
const productFinder = () => import('@/components/microComponents/productFinder');
import axios from "axios";
const BASE_URL = process.env.NODE_ENV === "production" ? process.env.VUE_APP_API_URL : "https://localhost:3000";
export default {
  name: "MyProjects",
  components: {
    Modal,
    productFinder
  },
  data() {
    return {
      count: 0,
      next: false,
      get_web_path: process.env.VUE_APP_SITE_URL,
      all_projects: [],
      uploadModal: false,
      kits: false,
      accessProfile: true,
      collab: false,
    };
  },
  watch: {
    kitsOwned: function (newVal) {
      if (newVal) this.kits = true;
    },
  },
  computed: {
    ...mapGetters({ courseData: "getFetchRecommended", collabrators: "getFetchCollabProjects" }),
  },
  methods: {
    ...mapActions(["getkitsOwned", "fetchRecommendedCourse"]),
    openModal() {
        this.$emit('openModal')
    },
    showModal() {
      if (this.$cookies.get("userAccess")) {
        this.uploadModal = true;
      } else {
        window.location.href = `${process.env.VUE_APP_SITE_URL}/login`;
      }
    },
    closeModal() {
      this.uploadModal = false;
    },
  },
  mounted() {
    if(this.$route.params.userName != undefined){
      this.accessProfile = false;
      var apiUrl = BASE_URL + "/projects/user/" + this.$route.params.userName; 
    } else {
      var apiUrl = BASE_URL + "/projects/user/";
    }
    axios.get(apiUrl).then(({ data }) => {
      if(data.data){
      this.count = data.data.filter((a)=>(a.is_deleted != 1 && a.is_approved == 1)).length;
      this.all_projects = data.data.filter((a)=>(a.is_deleted != 1 && a.is_approved == 1));
      } else {
        this.all_projects=false;
      }
    });
  },
  created() {
    if(this.$route.params.userName == undefined) this.fetchRecommendedCourse();
  },
};
</script>

<style lang="scss" scoped>
.my-projects-container {
  display: flex;
  margin-top: 2.5rem;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  .title-container {
    display: flex;
    width: 85%;
    align-items: center;
    justify-content: space-between;
    margin: 1.5rem 0;
    height: 6vh;
    .title {
      .space {
        margin: 0 3px;
      }
      .title-inner {
        position: relative;
        margin-right: 2rem;
        color: #2881c3;
        cursor: pointer;
        font-size: 1.25rem;
        &::after {
          content: "";
          width: 100%;
          height: 3px;
          position: absolute;
          background-color: #2881c3;
          left: 0;
          bottom: -5px;
          transition: width 0.5s;
        }
      }
      .in-active {
        color: #a0a0a0;
        &::after {
          width: 0;
          transition: width 0.5s;
        }
      }
    }
    .orange-button {
      width: 30%;
      height: 100%;
    }
    .utility {
      display: flex;
      align-items: center;
      outline: none;
      justify-content: center;
      .space {
        margin: 0 5px;
      }
      .span {
        font-family: Poppins;
        font-size: 1.25rem;
        font-weight: 500;
        color: #f36f2e;
      }
    }
    .mobile-utility {
      display: none;
      align-items: center;
      outline: none;
      justify-content: center;
      .space {
        margin: 0 5px;
      }
      .span {
        font-family: Poppins;
        font-size: 1.25rem;
        font-weight: 500;
        color: #f36f2e;
      }
    }
  }
  .no-project-no-kits {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    border: 1px solid #cacaca;
    border-radius: 8px;
    padding: 0 2rem;
    width: 85%;
    height: 40vh;
    .content {
      font-weight: 400;
      color: #303030;
    }
    .orange-button {
      background: #ffffff;
      color: #f36f2e;
      box-shadow: none;
      height: 15%;
      width: 30%;
    }
    .or {
      font-family: Roboto;
      font-size: 1rem;
      font-weight: 700;
      color: #303030;
    }
    .content {
      .highlight {
        font-weight: 500;
        color: #f36f2e;
        margin-right: 5px;
      }
    }
  }
  .no-project-but-kits {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    border: 1px solid #cacaca;
    border-radius: 8px;
    padding: 0 2rem;
    margin-bottom: 1rem;
    width: 85%;
    .sub-title {
      margin: 2% 0 0 0;
    }
    .content {
      margin: 1% 0 2% 0;
      color: #373737;
      font-weight: 400;
    }
    .course-card-container {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      flex-wrap: wrap;
      width: 100%;
      .course-card {
        display: flex;
        align-items: center;
        justify-content: space-between;
        border: 1px solid rgb(0, 0, 0, 0.07);
        flex-direction: column;
        flex-basis: 29%;
        border-radius: 8px;
        height: 40vh;
        margin: 0 2% 2% 2%;
        .course-thumbnail {
          width: 100%;
          border-top-left-radius: 8px;
          border-top-right-radius: 8px;
          height: 50%;
          object-fit: cover;
          background-color: #303030;
        }
        .sub-title {
          width: 90%;
          font-size: 1rem;
          font-weight: 600;
          text-align: left;
          color: #303030;
        }
        .content {
          width: 90%;
          font-size: 0.875rem;
          text-align: left;
          font-weight: 400;
          color: #303030;
        }
        .orange-button {
          background: #ffffff;
          color: #f36f2e;
          box-shadow: none;
          height: 15%;
          width: 90%;
          margin-bottom: 4%;
          .link-class {
            color: inherit;
            background: inherit;
          }
        }
      }
    }
  }
  .projects-added {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
    margin-bottom: 1rem;
    width: 85%;
    .project-card {
      display: flex;
      align-items: center;
      text-decoration: none;
      flex-direction: column;
      height: 50vh;
      justify-content: flex-start;
      margin: 0 2% 1rem 0;
      width: 32%;
      flex-basis: 32%;
      border: 1px solid rgb(0 0 0 / 7%);
      border-radius: 8px;
      box-shadow: 0px 2px 2px rgb(0 0 0 / 7%);
      .project-thumbnail {
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        background-position: center;
        background-size: cover;
        width: 100%;
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
        height: 70%;
        .thumbnail-overlay {
          display: flex;
          align-items: flex-end;
          flex-direction: column;
          justify-content: flex-end;
          width: 100%;
          border-top-left-radius: 8px;
          border-top-right-radius: 8px;
          height: 100%;
          .project-date {
            display: none;
            margin: 0.5rem;
            height: 10%;
            font-size: 0.875rem;
            font-weight: 400;
            color: #ffffff;
          }
          .button-container {
            display: flex;
            width: 100%;
            height: 90%;
            align-items: center;
            flex-direction: column;
            justify-content: center;
            .orange-button {
              display: none;
              outline: 0;
              background: #ffffff;
              box-shadow: 0px 2px 2px rgb(0 0 0 / 12%);
              border: 1px solid #ffffff;
              box-sizing: border-box;
              height: 20%;
              transform: translateY(-30%);
              width: 60%;
              font-size: 0.875rem;
              border-radius: 30px;
              color: #171717;
            }
          }
        }
      }
      .project-thumbnail:hover {
        .thumbnail-overlay {
          background-color: rgb(0 0 0 / 50%);
          background-position: center;
          background-size: 100% 100%;
          .project-date {
            display: initial;
          }
          .button-container {
            .orange-button {
              display: initial;
            }
          }
        }
      }
      .project-title {
        display: flex;
        align-items: center;
        margin: 0.5rem 0;
        height: 10%;
        width: 90%;
        justify-content: space-between;
        .sub-title {
          font-size: 1.125rem;
          display: flex;
          align-items: center;
          height: 100%;
          width: 80%;
          white-space: nowrap;
          overflow: hidden;
          text-align: left;
          color: #252525;
        }
        .project-views {
          display: flex;
          align-items: center;
          justify-content: center;
          .views-total {
            font-family: Roboto;
            margin-left: 5px;
            font-size: 0.875rem;
            font-weight: 500;
            color: #252525;
          }
        }
      }
      .content {
        margin-bottom: 0.5rem;
        width: 90%;
        overflow: auto;
        height: 15%;
        text-align: left;
        padding-right: 5px;
        font-size: 0.875rem;
        font-weight: 400;
        color: #252525;
      }
      &:nth-of-type(3n+3) {
        margin: 0 0 1rem 0;
      }
    }
  }
  .no-projects-no-access {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    width: 85%;
    height: 60vh;
    .no-projects-no-access-img-mobile{
      display: none;
    }
    .title{
      color: #303030;
    }
    .content{
      font-weight: 400;
      color: #303030;
    }
  }
  .loading {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 2rem 0;
    .sub-title {
      color: #f36f2e;
      margin: 0 1rem;
    }
  }
}
.title {
  font-family: Poppins;
  font-size: 1.5rem;
  font-weight: 600;
  color: #000000;
}
.sub-title {
  font-family: Poppins;
  font-size: 1.25rem;
  font-weight: 600;
  color: #151515;
}
.content {
  font-family: Roboto;
  font-size: 1rem;
  font-weight: 500;
  color: #151515;
}
.orange-button {
  font-family: Roboto;
  outline: 0;
  font-size: 1rem;
  font-weight: 500;
  background: #f36f2e;
  box-shadow: 0px 2px 2px rgb(0 0 0 / 12%);
  border: 1px solid #f36f2e;
  box-sizing: border-box;
  border-radius: 30px;
  color: white;
}
.scrollbar::-webkit-scrollbar {
  width: 5px;
  height: 5px;
  background-color: #f5f5f5;
}
.scrollbar::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  background-color: #9c9c9c;
}
@media all and (max-width: 1100px) {
  .my-projects-container {
    .title-container {
    width: 90%;
  }
    .no-project-but-kits {
      width: 90%;
      .sub-title {
        margin: 1rem 0 0 0;
      }
      .content {
        margin: 0.5rem 0 1rem 0;
      }
      .course-card-container {
        .course-card {
          width: 46%;
          flex-basis: 46%;
        }
      }
    }
    .projects-added {
      width: 90%;
      .project-card {
        width: 48%;
        flex-basis: 48%;
        &:nth-of-type(3n+3) {
          margin: 0 2% 1rem 0;
        }
        &:nth-of-type(2n+2) {
          margin: 0 0 1rem 0;
        }
      }
    }
  }
}
@media all and (max-width: 700px) {
  .my-projects-container {
    margin-top: 0;
    .title-container {
      width: 90%;
      .title {
        .space {
          margin: 0 1px;
        }
        .title-inner {
          font-size: 1rem;
          margin-right: 1.5rem;
        }
      }
      .orange-button {
        display: none;
      }
      .utility {
        display: none;
        .span {
          font-size: 1rem;
        }
      }
      .mobile-utility {
        display: flex;
        .span {
          font-size: 1rem;
        }
      }
    }
    .no-project-no-kits {
      width: 90%;
      height: 60vh;
      padding: 1rem 1.5rem;
      .orange-button {
        height: 10%;
        width: 90%;
      }
      .or {
        font-size: 0.875rem;
      }
    }
    .no-project-but-kits {
      padding: 0 1rem;
      .course-card-container {
        .course-card {
          width: 100%;
          flex-basis: 100%;
        }
      }
    }
    .projects-added {
      .project-card {
        width: 100%;
        flex-basis: 100%;
        margin: 0 0 1rem 0;
        .project-title {
          .sub-title {
            font-size: 1rem;
          }
        }
        &:nth-of-type(3n+3) {
          margin: 0 0 1rem 0;
        }
        &:nth-of-type(2n+2) {
          margin: 0 0 1rem 0;
        }
      }
    }
    .no-projects-no-access {
    width: 90%;
    height: 60vh;
    .no-projects-no-access-img{
      display: none;
    }
    .no-projects-no-access-img-mobile{
      display: initial;
      margin: 2rem 0;
    }
    .content{
      font-size: 1rem;
    }
  }
  }
  .title {
    font-size: 1.25rem;
  }
  .sub-title {
    font-size: 1.125rem;
  }
  .content {
    font-size: 0.875rem;
  }
}
</style>
